export const errorUnservedMappings = {
  NO_VEHICLE_MATCHES_TYPE: 'routeOptimization.error.noVehicleMatchesType',
  OVERCAPACITY: 'routeOptimization.error.overcapacity',
  EXCEEDS_OPERATIONAL_HOURS: 'routeOptimization.error.exceedsOperationalHours',
  OUTSIDE_DELIVERY_AREA: 'routeOptimization.error.outsideDeliveryArea',
  NO_COMPATIBLE_CONSTRAINT: 'routeOptimization.error.noCompatibleConstraint',
  NO_REASON_PROVIDED: 'routeOptimization.error.noReasonProvided',
  OUT_OF_STOCK: 'routeOptimization.error.outOfStock',
  OPTIMIZATION_FAILED_TO_FIT: 'routeOptimization.error.optimizationFailedToFit'
}
